import apiClient from "../../../../http-common";

// GRN Listing API
export const grnListing = (searchObj) => {
  return apiClient.post(`/grn/getGRNByFilter`, searchObj);
};

// View GRN API
export const getGRNById = (grnId) => {
  return apiClient.post(`/grn/getGRNDetails/${grnId}`);
};

// Approve GRN API
export const approveGRN = (grnId) => {
  return apiClient.put(`/grn/${grnId}/approve?status=true`);
};

//Invert GRN API
export const getGRNForInvert = (grnId) => {
  return apiClient.post(`/grn/getGRNInward/${grnId}`);
};

export const saveOrUpdateItemInfo = (itemData) => {
  return apiClient.post(`/item-info/saveOrUpdateItemInfo`, itemData);
};

// //Delete GRN API
// export const deleteGRN = (grnId) => {
//   return apiClient.delete(`/grn/${grnId}`);
// };
